import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-5">
      <div className="noise-overlay" />
      <div className="w-full max-w-md text-center" data-testid="payment-cancel">
        <XCircle className="text-zinc-500 mx-auto mb-6" size={30} />
        <h1 className="font-display font-black text-4xl tracking-tighter mb-4">
          Checkout cancelled
        </h1>
        <p className="font-body text-sm text-zinc-400 mb-8">
          No worries — you haven't been charged. The tape is still free, and the
          merch will be here when you're ready.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-zinc-400 hover:text-white transition-colors"
        >
          <ArrowLeft size={13} /> Back to FRE3BRD
        </Link>
      </div>
    </div>
  );
}
